import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ToastHelper from "../../utils/ToastHelper";
import * as Yup from "yup";
import ValidationHelper from "../../utils/ValidationHelper";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import CredentialService from "../../services/admin/CredentialService";
import LoadingSpinnerComponent from "../../components/LoadingSpinnerComponent";
import UserSessionService from "../../services/UserSessionService";

const UPDATE_PASSWORD_CONFIG = [
  {
    dataField: "currentPassword", dataLabel: "Current Password", type: "password",
    yup: Yup.string()
      .required('Current Password is required')
      .min(5, "Password must be at least 5 characters")
  },
  {
    dataField: "newPassword", dataLabel: "New Password", type: "password",
    yup: Yup.string()
      .required('New Password is required')
      .min(8, "Password must be at least 8 characters")
      .matches(/(?=.*\W)/, "Password must contain at least special case character")
      .matches(/(?=.*[a-z])/, "Password must contain at least one lowercase character")
      .matches(/(?=.*[A-Z])/, "Password must contain at least one uppercase character")
      .matches(/(?=.*\d)/, "Password must contain at least one number")
  },
  {
    dataField: "confirmNewPassword", dataLabel: "Confirm New Password", type: "password",
    yupMatch: 'newPassword',
    yup: Yup.string()
      .required('Confirm New Password is required')
      .min(8, "Password must be at least 8 characters")
      .matches(/(?=.*\W)/, "Password must contain at least special case character")
      .matches(/(?=.*[a-z])/, "Password must contain at least one lowercase character")
      .matches(/(?=.*[A-Z])/, "Password must contain at least one uppercase character")
      .matches(/(?=.*\d)/, "Password must contain at least one number")
  },
];
const USERNAME_KEY = 'username';

class UpdatePasswordComponent extends Component {

  constructor(props) {
    super(props);

    this.validationSchema = ValidationHelper.buildValidationSchema(UPDATE_PASSWORD_CONFIG);
    this.formRef = null;

    this.state = {
      isLoading: true,
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      errors: {},
      mobile: this.isMobile(), // on mobile, we swap the SFX logo above the Login components
      passwordChangeSuccessfulPopUp: false,
      firstLoad: true,
      passwordChangeSuccessPopUp: false,
      passwordEnteredIncorrectlyPopUp: false,
      passwordChangeConfirmationPopUp: false
    };

    this.handleResize = this.handleResize.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.isMobile = this.isMobile.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({
      isLoading: false,
      passwordExpired: true
    });
  }

  handleChange = event => {
    let value = event.target.value;

    let jsonObj = {};
    jsonObj["currentPassword"] = this.state.currentPassword;
    jsonObj["newPassword"] = this.state.newPassword;
    jsonObj["confirmNewPassword"] = this.state.confirmNewPassword;
    jsonObj[event.target.id] = value;

    let errors = ValidationHelper.validate(this.validationSchema, jsonObj);

    this.setState({
      firstLoad: false,
      [event.target.id]: event.target.value,
      errors: errors
    });
  };

  handleSubmit = function (event) {
    event.preventDefault();

    let self = this;
    let username = sessionStorage.getItem(USERNAME_KEY);

    CredentialService.changePassword(username, this.state.currentPassword, this.state.newPassword).then(response => {
        if (response === "success") {
          self.toggleConfirmPassword();
          self.togglePasswordChangeSuccessful();

          UserSessionService.logout();
        } else {

          self.toggleConfirmPassword();
          self.togglePasswordEnteredIncorrectly();
          ToastHelper.formatError(response);
        }
      }
    );
  };

  validateForm() {
    return this.state.errors["currentPassword"] === undefined && this.state.errors["newPassword"] === undefined && this.state.errors["confirmNewPassword"] === undefined && this.state.firstLoad === false;
  }

  togglePasswordChangeSuccessful() {
    this.setState({
      passwordChangeSuccessfulPopUp: !this.state.passwordChangeSuccessPopUp
    })
  }

  togglePasswordEnteredIncorrectly() {
    this.setState({
      passwordEnteredIncorrectlyPopUp: !this.state.passwordEnteredIncorrectlyPopUp
    })
  }

  toggleConfirmPassword() {
    this.setState({
      passwordChangeConfirmationPopUp: !this.state.passwordChangeConfirmationPopUp
    })
  }

  goBack(){
    this.props.history.push("/logout");
  }

  isMobile() {
    return window.innerWidth < 575;
  }

  handleResize() {
    if (window) {
      this.setState({mobile: this.isMobile()});
    }
  }

  componentWillMount() {
    if (window) window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    if (window) window.removeEventListener('resize', this.handleResize);
  }

  render() {
    if (this.state.isLoading) {
      return <Fragment>
        <LoadingSpinnerComponent/>
      </Fragment>
    } else {

      let LoginStyle = {
        fontSize: '7vw'
      };

      let SignInStyle = {
        fontSize: '3vw'
      };

      let head = <Col>
        <div className="LoginContainer">
          <h1>Update Password</h1>
        </div>
      </Col>

      const logo = (divClass, imgClass) => <Col className={divClass}><img className={imgClass}
                                                                          src={"/assets/img/ria-logo.png"}
                                                                          alt=""/></Col>;
      let first = '';
      let second = '';

      if (this.state.mobile) {

        second = <Col><img className="logo pull-right" src={"/assets/img/ria-logo.png"} alt="" width="auto"
                           height="auto"/></Col>;
        first =
          <Col><h1 style={LoginStyle}>Login</h1><p className="text-muted" style={SignInStyle}>Password Update</p></Col>;
      } else {
        first = head;
        second = logo('', 'logo pull-right');
      }

      return (
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <CardGroup>
                  <Card className="p-2">
                    <CardBody>
                      <Form noValidate
                            onSubmit={this.handleSubmit}>
                        <Row>
                          {first}
                          {second}
                        </Row>
                        <p style={{color: "red"}}>The password you entered has expired. Please update your password to log in</p>
                        <main>
                          <ToastContainer position="top-right" autoClose={5000} style={{zIndex: 1999}}/>
                        </main>
                        <FormGroup>
                          <InputGroup className="mb-5">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fa fa-key"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input type="password" placeholder="Current Password"
                                   autoComplete="username"
                                   id="currentPassword"
                                   onChange={this.handleChange}
                                   value={this.state.currentPassword}
                                   invalid={this.state.errors["currentPassword"] !== undefined}
                            />
                            <FormFeedback>{this.state.currentPassword === '' ? '' : this.state.errors["currentPassword"]}</FormFeedback>

                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fa fa-key"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input type="password" placeholder="New Password"
                                   id="newPassword"
                                   onChange={this.handleChange}
                                   value={this.state.newPassword}
                                   invalid={this.state.errors["newPassword"] !== undefined}
                            />
                            <FormFeedback>{this.state.newPassword === '' ? '' : this.state.errors["newPassword"]}</FormFeedback>

                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fa fa-key"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input type="password" placeholder="Confirm New Password"
                                   id="confirmNewPassword"
                                   onChange={this.handleChange}
                                   value={this.state.confirmNewPassword}
                                   invalid={this.state.errors["confirmNewPassword"] !== undefined}
                            />

                            <FormFeedback>{this.state.confirmNewPassword === '' ? '' : this.state.errors["confirmNewPassword"]}</FormFeedback>

                          </InputGroup>
                        </FormGroup>
                        <Row>
                          <Col>
                            <SFXButtonComponent md={2}
                                                className="btn btn-success"
                                                disabled={!this.validateForm()}
                            >Submit</SFXButtonComponent>
                            {'  '}
                            <SFXButtonComponent md={2} className="btn btn-secondary"
                                                onClick={this.goBack}
                            >Back</SFXButtonComponent>
                          </Col>
                        </Row>
                      </Form>


                    </CardBody>
                  </Card>
                </CardGroup>

                <Modal isOpen={this.state.passwordChangeSuccessfulPopUp} toggle={this.toggle}
                       className={'modal-primary modal-sd ' + this.props.className}>
                  <ModalHeader toggle={this.toggle}>Password Update</ModalHeader>
                  <ModalBody>
                    Your password has been changed. Please login again with the new password.
                  </ModalBody>
                  <ModalFooter>
                    <SFXButtonComponent className={"btn btn-success"}
                                        onClick={this.togglePasswordChangeSuccessful.bind(this)}
                                        href={"/login"}
                    >Ok</SFXButtonComponent>
                  </ModalFooter>
                </Modal>

              </Col>
            </Row>
          </Container>
        </div>

      );
    }
  }
}

export default UpdatePasswordComponent;




// WEBPACK FOOTER //
// ./src/views/Profile/UpdatePasswordComponent.js